import { Box, Container, Modal, Paper, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'src/components/button';

import { theme } from '../../../styles/theme';

interface CommonLawTenancyModalProps {
    bookingId: string;
    userId: string;
}

export const CommonLawTenancyModal: FC<CommonLawTenancyModalProps> = ({ bookingId, userId }) => {
    const { t } = useTranslation();

    return (
        <Modal open>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%" px={2}>
                <Container maxWidth="sm" css={{ textAlign: 'center' }}>
                    <Paper sx={{ borderRadius: 0, p: 4 }}>
                        <Stack spacing={3}>
                            <Typography variant="h4" textTransform="uppercase">
                                {t('renters_rights_modal_title')}
                            </Typography>

                            <Typography variant="body1">
                                {t('renters_rights_modal_body')}
                            </Typography>

                            <Button
                                fullWidth
                                onClick={() =>
                                    window.open(
                                        `https://salesforce-eu.123formbuilder.com/form-90741/?control3500229=${bookingId}&control3505528=${userId}`
                                    )
                                }
                                css={{
                                    backgroundColor: theme.palette.primary.main,
                                    color: 'white',
                                    textTransform: 'uppercase',
                                }}
                            >
                                {t('renters_rights_modal_cta')}
                            </Button>
                            <Typography variant="body2" color="textSecondary">
                                {t('renters_rights_modal_small_print')}
                            </Typography>
                        </Stack>
                    </Paper>
                </Container>
            </Box>
        </Modal>
    );
};
